// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"125":"a3e6eb62","314":"15ab57b8","865":"0659e547"}[chunkId] + ".js";
};